import { useEffect } from 'react';

/**
 * Hook que garante que o body sempre permaneça clicável após fechar modais
 * Resolve o problema de modais do Radix UI bloquearem cliques após fechar
 */
export function useModalCleanup() {
  useEffect(() => {
    const observer = new MutationObserver(() => {
      // Verifica se há algum modal aberto
      const hasOpenModal = document.querySelector(
        '[data-radix-dialog-content][data-state="open"], ' +
        '[data-radix-alert-dialog-content][data-state="open"]'
      );

      // Se não há modal aberto, garante que o body está clicável
      if (!hasOpenModal) {
        document.body.style.removeProperty('pointer-events');
        document.body.style.overflow = '';

        // Remove atributos que o Radix adiciona
        document.body.removeAttribute('data-scroll-locked');
      }
    });

    // Observa mudanças nos portals do Radix
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-state', 'style']
    });

    // Cleanup ao desmontar
    return () => {
      observer.disconnect();
      document.body.style.removeProperty('pointer-events');
      document.body.style.overflow = '';
      document.body.removeAttribute('data-scroll-locked');
    };
  }, []);
}
